import React from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonText } from '@nucleus/web-theme-elements';

export const PostListItemSkeleton = (): JSX.Element => {
  return (
    <Container>
      <ImagePlaceholder />
      <Meta>
        <SkeletonText width="25%" style={{ height: 10, marginBottom: 10 }} />
        <SkeletonText width="70%" style={{ height: 18, marginBottom: 12 }} />
        <TextBlock>
          <SkeletonText width="100%" style={{ height: 12, marginBottom: 4 }} />
          <SkeletonText width="90%" style={{ height: 12, marginBottom: 4 }} />
          <SkeletonText width="60%" style={{ height: 12 }} />
        </TextBlock>
      </Meta>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 20px 0;
  border-bottom: 1px solid ${({ theme }) => theme._webThemeElements.Skeleton?.colorDark ?? 'rgba(0, 0, 0, 0.06)'};
`;

const ImagePlaceholder = styled(SkeletonBlock)`
  width: 180px;
  min-width: 180px;
  aspect-ratio: 16 / 9;
  border-radius: 8px;

  @media (max-width: 800px) {
    width: 100px;
    min-width: 100px;
  }
`;

const Meta = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 4px;
`;

const TextBlock = styled.div`
  max-width: 60%;
`;
